import React from 'react';

import { TagList as SharedTagList } from '../../../../../../shared/components/Filter';
import { useCalendar, useFilters } from '../../../../hooks';

const TagList = () => {
  const { tags } = useCalendar();
  const { activeFilters, toggleFilter } = useFilters();

  return (
    <SharedTagList
      onToggle={(value) => toggleFilter({ type: 'tags', value })}
      selectedIds={activeFilters.tags}
      tags={tags}
    />
  );
};

export default TagList;
